import React from "react";
import { useSearchParams } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import MhMFlow from "../components/tools/mhm/MhMFlow";
import { API } from "../App";

const MhMCampaignPage = () => {
  const [searchParams] = useSearchParams();
  const leadId = searchParams.get("lead") || null;

  return (
    <div className="min-h-screen bg-[#FAF8F5]" data-testid="mhm-campaign-page">
      <div className="bg-white border-b border-[#E8E3DE] shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-[#87A96B] flex items-center justify-center">
              <BarChart3 className="w-5 h-5 text-white" />
            </div>
            <div>
              <p className="text-sm font-semibold text-[#4A4543]">MyHomeMatrix</p>
              <p className="text-xs text-[#B0A898]">Discover what truly matters in your home search</p>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 py-6">
        <MhMFlow apiBase={API} leadId={leadId} isPublicView={true} />
      </div>
      <div className="bg-white border-t border-[#E8E3DE] mt-8">
        <div className="max-w-4xl mx-auto px-4 py-4 text-center">
          <p className="text-xs text-[#B0A898]">Powered by PropertyCRM</p>
        </div>
      </div>
    </div>
  );
};

export default MhMCampaignPage;
